var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7FE1280-6C7C-45E2-A3A0-50948FF2EDEA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.27272727,5 L9,5 L9,7 L3.27272727,7 L3.27272727,5 Z M16.3636364,0 L0,0 L0,14 L18,14 L18,0 L16.3636364,0 Z M16.3636364,12 L1.63636364,12 L1.63636364,3 L16.3636364,3 L16.3636364,12 Z M3.27272727,9 L14.7272727,9 L14.7272727,10 L3.27272727,10 L3.27272727,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SUEZ-PCE_UI_Lot1_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_SUEZ-PCE_UI_client_05_accueil",
    transform: "translate(-86.000000, -339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Latest-documents",
    transform: "translate(60.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Facture",
    transform: "translate(26.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Couleur/bleue-clair*",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-/-Fill-/-Vert-Vivic",
    mask: "url(#mask-2)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 7.000000) rotate(-90.000000) translate(-9.000000, -7.000000) translate(-1.000000, -5.000000)",
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 24
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacture);
export default __webpack_public_path__ + "static/media/facture.dc1b8902.svg";
export { ForwardRef as ReactComponent };